import { Stack } from "@mui/material";
import { CompactChallenge } from "Components/Shared/Challenge/CompactChallenge/CompactChallenge";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";
import { CompactChallengeSkeleton } from "Components/Shared/Challenge/CompactChallenge/CompactChallengeSkeleton";

type Props = {
  challenges: Array<LoyaltyEventDto>;
  isLoading: boolean;
};

export const CompactChallenges = ({ challenges, isLoading }: Props) => (
  <Stack gap={2}>
    {isLoading ? (
      <CompactChallengesSkeleton />
    ) : (
      challenges.map(({ code, points, isCompleted, loyaltyPointType }) => (
        <CompactChallenge
          key={code}
          event={code}
          points={points}
          isCompleted={isCompleted}
          loyaltyPointType={loyaltyPointType}
        />
      ))
    )}
  </Stack>
);

const CompactChallengesSkeleton = () => (
  <>
    <CompactChallengeSkeleton />
    <CompactChallengeSkeleton />
  </>
);
